import { createAction } from "@reduxjs/toolkit";

export const startTimeout = createAction("startTimeout");
